import { render, staticRenderFns } from "./NestedMenu.vue?vue&type=template&id=67944ac6&"
import script from "./NestedMenu.vue?vue&type=script&lang=js&"
export * from "./NestedMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports